import { Icon } from '@chakra-ui/react';

export default function SFRecordCircleFilledIcon(props) {
  return (
    <Icon
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M10 16.9402C6.3737 16.9402 3.35938 13.9259 3.35938 10.2996C3.35938 6.66675 6.36719 3.65894 9.99349 3.65894C13.6263 3.65894 16.6406 6.66675 16.6406 10.2996C16.6406 13.9259 13.6328 16.9402 10 16.9402ZM10.013 12.9233C11.4648 12.9233 12.6432 11.7449 12.6432 10.2865C12.6432 8.83472 11.4648 7.66284 10.013 7.66284C8.55469 7.66284 7.3763 8.83472 7.3763 10.2865C7.3763 11.7449 8.55469 12.9233 10.013 12.9233Z' />
    </Icon>
  );
}
